import { useContext } from "react";
import { ThemeContext } from "../../../..";

const TableRows=({ rowsData, deleteTableRows, handleChange }) =>{
  const { theme } = useContext(ThemeContext);
  return rowsData.map((data, index) => {
    const { attributeName, attributeValue} = data;
    return (
      <tr key={index}>
        <td style={{background: theme === "light" ? "white" : "transparent" }}>
          <input
            type="text"
            value={attributeName}
            onChange={(evnt) => handleChange(index, evnt)}
            name="attributeName"
            className={theme === "light" ? "form-control-light  form__input-light" : "form-control  form__input"}
          />
        </td>
        <td style={{background: theme === "light" ? "white" : "transparent" }}>
          <input
            type="text"
            value={attributeValue}
            onChange={(evnt) => handleChange(index, evnt)}
            name="attributeValue"
            className={theme === "light" ? "form-control-light  form__input-light" : "form-control  form__input"}
          />{" "}
        </td>
        
        <td style={{background: theme === "light" ? "white" : "transparent" }}>
          <input type="button"
            className="btn btn-outline-danger"
            onClick={() => deleteTableRows(index)}
            value={"x"}
          />
           
        </td>
      </tr>
    );
  });
}

export default TableRows;
